<template>
  <base-modal wide form :title="`New ${Naming.JobType}`">
    <div class="columns is-multiline">
      <div class="column is-6">
        <text-input
          placeholder="ex: Repair, Survey, etc…"
          required
          :error="$root.errors.description"
          :value="jobType.description"
          @input="description">
          Description
        </text-input>
      </div>
      <div class="column is-6">
        <number-input
          :precision="0"
          :min="50"
          :max="100"
          required
          :error="$root.errors.pass_percentage"
          :value="jobType.pass_percentage"
          @input="passPercentage">
          Pass Percentage
        </number-input>
      </div>
      <div class="column is-6">
        <switch-input
            :description="`${Naming.JobTypes} that are not active will not be available on ${Naming.Jobs.toLowerCase()}`"
            classes="is-medium"
            @input="toggleActive"
            :value="jobType.active">
          Active {{ Naming.JobType }}
        </switch-input>
      </div>
      <div class="column is-6">
        <switch-input
            :description="`When required, ${Naming.Jobs.toLowerCase()} of this type will require the customer to provide their name as well as a signature before closing it off.`"
            classes="is-medium"
            @input="toggleSignatureRequirement"
            :value="jobType.requires_signature">
          Requires a Signature
        </switch-input>
      </div>
      <div class="column is-6">
        <switch-input
          :description="`${Naming.Jobs} which carry this ${Naming.JobType.toLowerCase()} will be limited to 1 ${Naming.Inspection.toLowerCase()} per ${Naming.Job.toLowerCase()}.`"
          classes="is-medium"
          @input="toggleSingleInspection"
          :value="jobType.single_inspection">
          Limit {{ Naming.Jobs }} to 1 {{ Naming.Inspection.toLowerCase() }} per {{ Naming.Job.toLowerCase() }}.
        </switch-input>
      </div>
      <div class="column is-6">
        <switch-input
          :description="`Display map (if available) on the ${Naming.Inspection.toLowerCase()} report PDF.`"
          classes="is-medium"
          @input="toggleMapOnReport"
          :value="jobType.report_with_map">
          {{ Naming.Inspection }} Report - Show Map
        </switch-input>
      </div>
      <div class="column is-6">
        <switch-input
          :description="`Display ${Naming.CustomField.toLowerCase()} meta data for the ${Naming.Asset.toLowerCase()} on the PDF ${Naming.Inspection.toLowerCase()} report.`"
          classes="is-medium"
          @input="toggleAssetMetaFieldsOnInspectionReport"
          :value="jobType.report_with_asset_meta">
          {{ Naming.Inspection }} Report - Show {{ Naming.Asset }} {{ Naming.CustomFields }}
        </switch-input>
      </div>
      <div class="column is-6">
        <switch-input
          :description="`Display ${Naming.CustomField.toLowerCase()} meta data for the ${Naming.Asset.toLowerCase()} on the PDF ${Naming.Job.toLowerCase()} report.`"
          classes="is-medium"
          @input="toggleAssetMetaFieldsOnJobReport"
          :value="jobType.job_report_with_asset_meta">
          {{ Naming.Job }} Report - Show {{ Naming.Asset }} {{ Naming.CustomFields }}
        </switch-input>
      </div>
      <div class="column is-6">
        <switch-input
            :description="`When required, ${Naming.Jobs.toLowerCase()} of this type will require the ${Naming.Technician.toLowerCase()} to sign for the ${Naming.Job.toLowerCase()} and ${Naming.Inspections.toLowerCase()} at ${Naming.Job.toLowerCase()} closure.`"
            classes="is-medium"
            @input="toggleTechnicianSignatureRequirement"
            :value="jobType.requires_technician_signature">
          Requires {{ Naming.Technician }} Signature
        </switch-input>
      </div>
    </div>

    <template #footer>
      <submit-button :working="working" @submit="store" class="is-success is-rounded" left-icon="check">Create {{ Naming.JobType }}</submit-button>
    </template>
  </base-modal>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {

  data: () => ({
    working: false
  }),

  beforeDestroy() {
    this.clearJobType()
  },

  methods: {
    ...mapMutations('jobType', [
      'description',
      'clearJobType',
      'passPercentage',
      'toggleActive',
      'toggleSignatureRequirement',
      'toggleSingleInspection',
      'toggleMapOnReport',
      'toggleAssetMetaFieldsOnInspectionReport',
      'toggleAssetMetaFieldsOnJobReport',
      'toggleTechnicianSignatureRequirement'
    ]),
    store() {
      this.working = true
      this.$store.dispatch('jobType/store').then(jobType => {
        this.$toast.success(this.Convert(this.$lang.jobType.created))
        this.working = false
        this.$close(jobType)
      }).catch(error => {
        this.working = false
        this.$whoops()
      })
    }
  },

  computed: {
    ...mapGetters('jobType', [
      'jobType'
    ])
  }
}
</script>
